const getHome = (ajaxinstance) => {
  const customer = {}

  // 判断是否需要授权--------------
  customer.isLogin = (postData) => {
    return ajaxinstance.post('/index/login/isLogin', postData)
  }
  
  // 获取授权地址--------------
  customer.authurl = (postData) => {
    return ajaxinstance.post('/index/weixin/authurl', postData)
  }
  
  return customer
}

export default getHome



// WEBPACK FOOTER //
// ./src/common/apis/authorization.js